import { Component } from 'shimmer'

import { Loader } from '@/utils/Loader'

import {
  PlaneBufferGeometry,
  MeshNormalMaterial,
  DirectionalLight,
  AmbientLight,
  Vector3
} from 'three'

import { webGL } from '@/webGL/WebGL'

export class Scenery extends Component {
  constructor (url) {
    super('Scenery')

    this.destroy = this.destroy.bind(this)

    this.loader = Loader.load(url, false, obj => {
      obj.receiveShadow = true
      obj.castShadow = false
    }).then(obj => {
      this.object = obj
      this.object.scale.set(70, 70, 70)
      this.add(this.object)
    })

    this.addLights()

    this.loader.then(this.resolve)
  }

  destroy () {
    this.onDestroy()

    this.object.traverse(child => {
      if (child.isMesh) {
        child.material.dispose()
        child.geometry.dispose()
      }
    })

    webGL.scene.remove(this.directional)
    webGL.objectScene.remove(this.directionalClone)
    webGL.scene.remove(this.ambient)
    webGL.objectScene.remove(this.ambientClone)
  }

  addLights () {
    this.directional = new DirectionalLight(0xffffff, 1)
    this.directional.position.set(-1200, 900, 1000)
    this.directional.lookAt( new Vector3(0, 0, 0) )
    webGL.scene.add(this.directional)

    this.directionalClone = this.directional.clone()
    this.directionalClone.castShadow = true
    this.directionalClone.shadow.camera.bottom = -1000
    this.directionalClone.shadow.camera.top = 1000
    this.directionalClone.shadow.camera.left = -1000
    this.directionalClone.shadow.camera.right = 1000
    this.directionalClone.shadow.camera.far = 20000
    this.directionalClone.shadow.camera.near = 100
    this.directionalClone.shadow.mapSize.width = 2048
    this.directionalClone.shadow.mapSize.height = 2048
    this.directionalClone.shadow.bias = -0.0004
    this.directionalClone.shadow.camera.updateProjectionMatrix()
    webGL.objectScene.add(this.directionalClone)

    this.ambient = new AmbientLight(0xffffff, .3)
    this.ambientClone = this.ambient.clone()
    webGL.scene.add(this.ambient)
    webGL.objectScene.add(this.ambientClone)
  }
}